import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VisaoEstruturaResponse } from '@interfaces/corporate-registry/responses/rede-visoes.response';
import { VaultMaskCnpjPipe } from '@shared/pipes/vault-mask-cnpj.pipe';
import { injectOwnershipNetworkDisplay } from '@shared/components/ownership-network/ownership-network-display';

/**
 * Pessoas jurídicas que são sócias de duas ou mais empresas do recorte — o indício de holding.
 * O rodapé diz o que o indício NÃO prova, e isso é parte da tela, não enfeite.
 */
@Component({
  selector: 'app-registry-structures',
  standalone: true,
  imports: [CommonModule, VaultMaskCnpjPipe],
  templateUrl: './registry-structures.component.html',
  styleUrl: './registry-structures.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryStructuresComponent {
  protected readonly display = injectOwnershipNetworkDisplay();
  readonly visao = input.required<VisaoEstruturaResponse>();
  protected readonly ehCnpj = (doc: string | null) => /^\d{14}$/.test(doc ?? '');
}
